import i18next from 'i18next'
import * as React from 'react'
import { FileGuideErrorModal } from './FileGuideErrorModal'

interface Props {
    onBack: () => void
    onTryAgain: () => void
}

export function FileGuideNotFoundModal(props: Props) {
    return (
        <FileGuideErrorModal
            description={i18next.t('appcore:FileGuideNotFoundModal.description')}
            onBack={props.onBack}
            onTryAgain={props.onTryAgain}
            title={i18next.t('appcore:common.errorOccurred')}
        />
    )
}
